import React, { useState } from 'react';
import useScrollAnimation from './useScrollAnimation';

const specsCategories = [
  {
    id: 'display',
    title: 'Display & Design',
    items: [
      { label: 'Screen Sizes', val: '6.7-inch (diagonal) or 6.1-inch all-screen OLED' },
      { label: 'Resolution', val: '2796-by-1290-pixel resolution at 460 ppi' },
      { label: 'ProMotion Tech', val: 'Adaptive refresh rates up to 120Hz' },
      { label: 'Brightness', val: '1000 nits typical, 1600 nits HDR, 2000 nits peak outdoor' },
      { label: 'Durability', val: 'Ceramic Shield front, textured matte glass back and titanium design' },
      { label: 'Water Resistance', val: 'Rated IP68 (maximum depth of 6 meters up to 30 minutes)' }
    ]
  },
  {
    id: 'chip',
    title: 'Chip & Performance',
    items: [
      { label: 'Processor', val: 'A17 Pro Bionic chip' },
      { label: 'CPU Architecture', val: 'New 6-core CPU with 2 performance and 4 efficiency cores' },
      { label: 'GPU Architecture', val: 'New 6-core GPU with hardware-accelerated ray tracing' },
      { label: 'Neural Engine', val: 'New 16-core Neural Engine for on-device AI tasks' },
      { label: 'Manufacturing Process', val: 'Industry-leading 3-nanometer architecture' }
    ]
  },
  {
    id: 'camera',
    title: 'Camera & Video',
    items: [
      { label: 'Main Camera', val: '48MP Main: 24 mm, ƒ/1.78 aperture, 2nd-gen sensor-shift OIS' },
      { label: 'Ultra Wide', val: '12MP Ultra Wide: 13 mm, ƒ/2.2 aperture and 120° field of view' },
      { label: 'Telephoto Zoom', val: '12MP 5x Telephoto: 120 mm, ƒ/2.8 aperture, 3D sensor-shift OIS' },
      { label: 'Video Recording', val: '4K video recording at 24 fps, 25 fps, 30 fps, or 60 fps' },
      { label: 'ProRes Video', val: 'ProRes video recording up to 4K at 60 fps with external recording' },
      { label: 'Cinematic Mode', val: 'Cinematic mode up to 4K HDR at 30 fps with automatic rack focus' }
    ]
  },
  {
    id: 'power',
    title: 'Power & Battery',
    items: [
      { label: 'Video Playback', val: 'Up to 29 hours of continuous video playback' },
      { label: 'Audio Playback', val: 'Up to 95 hours of continuous audio playback' },
      { label: 'Fast Charge', val: 'Up to 50% charge in ~30 minutes with 20W adapter or higher' },
      { label: 'Wireless Charging', val: 'MagSafe wireless charging up to 15W and Qi wireless charging up to 7.5W' },
      { label: 'Connector', val: 'USB-C connector supporting USB 3 up to 10Gb/s data transfers' }
    ]
  }
];

const SpecificationsSection = () => {
  const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.15 });
  const [activeTab, setActiveTab] = useState('display');

  const currentCategory = specsCategories.find((c) => c.id === activeTab) || specsCategories[0];

  return (
    <section 
      ref={sectionRef} 
      className={`specs-section ${isVisible ? 'is-visible' : ''}`}
      id="specs"
    >
      <div className="section-container">
        {/* Section Header */}
        <div className="text-center specs-header scroll-fade-up">
          <span className="section-eyebrow">Technical Specifications</span>
          <h2 className="section-headline">Pro in every single detail.</h2>
        </div>

        {/* Specs Category Tabs */}
        <div className="specs-tabs-row scroll-fade-up">
          {specsCategories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveTab(cat.id)}
              className={`specs-tab-btn ${activeTab === cat.id ? 'active' : ''}`}
            >
              {cat.title}
            </button>
          ))}
        </div>

        {/* Specs Detail Box */}
        <div className="specs-content-card scroll-scale-up">
          <div className="specs-card-header">
            <h3 className="specs-category-title">{currentCategory.title}</h3>
            <span className="specs-model-tag">Peace i17 Air Specs</span>
          </div>

          <div className="specs-grid-table">
            {currentCategory.items.map((item, idx) => (
              <div key={idx} className="spec-row-item">
                <div className="spec-item-label">{item.label}</div>
                <div className="spec-item-value">{item.val}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecificationsSection;
